import request from "@/service";

/* 查询发布主体列表 */
export function page(params) {
  return request({
    url: `/resource/shortVideo/publisher/page?name=${
      params.name ? params.name : ""
    }`,
    method: "get"
  });
}

/* 新增发布主体列表 */
export function publisherAdd(data) {
  return request({
    url: `/resource/shortVideo/publisher/save`,
    method: "post",
    data
  });
}
/* 修改发布主体列表 */
export function publisherEdit(data) {
  return request({
    url: `/resource/shortVideo/publisher/update`,
    method: "put",
    data
  });
}
/*发布主体列表详情 */
export function publisherDetail(id) {
  return request({
    url: `/resource/shortVideo/publisher/${id}`,
    method: "get"
  });
}
/*发布主体列表删除*/
export function publisherDelete(data) {
  return request({
    url: `/resource/shortVideo/publisher/delete`,
    method: "delete",
    data
  });
}
/* 拖拽排序 */
export function updateOrderByDrag(data) {
  return request({
    url: "/resource/shortVideo/publisher/updateOrderByDrag",
    method: "put",
    data
  });
}

/* 查询发布主体上线列表 */
export function publisherList() {
  return request({
    url: `/resource/shortVideo/publisher/findListByOnlineStatus`,
    method: "get"
  });
}
